import { FormInsightsOverviewDocument } from 'generated/resources/graphql'
import type { Dictionary } from 'lodash'

import { useGraphqlDataCollectionSource } from 'modules/core/hooks/useGraphqlDataCollectionSource'

import { useFormInsightsFilters } from './useFormInsightsFilters'

export function useFormInsightsDataSource({
  formId,
  resourceType,
  currentFilters,
}: {
  formId: string
  resourceType: string
  currentFilters: Dictionary<unknown>
}) {
  const filters = useFormInsightsFilters()
  const currentFiltersKey = JSON.stringify(currentFilters)

  return useGraphqlDataCollectionSource(
    {
      document: FormInsightsOverviewDocument,
      mapData: (data) => {
        return data.forms.elements ?? []
      },
      mapPagination: (data) => ({
        total: data.forms.elements?.length ?? 0,
      }),
      mapVariables: () => ({
        formId,
      }),
      currentFilters,
      filters,
      paginationType: 'infinite-scroll',
    },
    [formId, resourceType, filters, currentFiltersKey]
  )
}
